// // import React, {
// //   useEffect,
// //   useLayoutEffect,
// //   useMemo,
// //   useRef,
// //   useState,
// // } from "react";
// // import {
// //   IconArrow,
// //   IconDoc,
// //   IconSearch,
// //   IconDownload,
// //   IconChevronDown,
// //   IconCalendar,
// //   IconUser,
// //   IconClose,
// //   IconSliders,
// //   IconLayers,
// //   IconClock,
// //   IconChart,
// // } from "./icons";
// // import {
// //   CATEGORIES,
// //   CATEGORY_MAP,
// //   TYPE_STYLES,
// //   DOCUMENTS,
// //   optionsFor,
// //   formatDownloads,
// //   formatSize,
// //   openDoc,
// //   downloadDoc,
// // } from "../data/Research";

// // /* ----------------------------- tiny utilities ---------------------------- */
// // function useInView(opts = {}) {
// //   const ref = useRef(null);
// //   const [inView, setInView] = useState(false);
// //   useEffect(() => {
// //     const el = ref.current;
// //     if (!el) return;
// //     const ob = new IntersectionObserver(
// //       ([e]) => {
// //         if (e.isIntersecting) {
// //           setInView(true);
// //           ob.disconnect();
// //         }
// //       },
// //       { threshold: 0.12, ...opts }
// //     );
// //     ob.observe(el);
// //     return () => ob.disconnect();
// //   }, []);
// //   return [ref, inView];
// // }

// // function Reveal({ children, delay = 0, className = "" }) {
// //   const [ref, inView] = useInView();
// //   return (
// //     <div
// //       ref={ref}
// //       className={`transition-all duration-700 ease-out ${
// //         inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
// //       } ${className}`}
// //       style={{ transitionDelay: `${delay}ms` }}
// //     >
// //       {children}
// //     </div>
// //   );
// // }

// // /* Number that tweens up the first time it scrolls into view, and re-tweens
// //    whenever its value changes afterwards (i.e. on tab switch). */
// // function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
// //   const [ref, inView] = useInView();
// //   const [display, setDisplay] = useState(0);
// //   const fromRef = useRef(0);
// //   useEffect(() => {
// //     if (!inView) return;
// //     const from = fromRef.current;
// //     const to = value;
// //     const start = performance.now();
// //     let raf;
// //     const tick = (now) => {
// //       const t = Math.min(1, (now - start) / duration);
// //       const eased = 1 - Math.pow(1 - t, 3);
// //       const cur = Math.round(from + (to - from) * eased);
// //       setDisplay(cur);
// //       if (t < 1) raf = requestAnimationFrame(tick);
// //       else fromRef.current = to;
// //     };
// //     raf = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(raf);
// //   }, [inView, value, duration]);
// //   return <span ref={ref}>{format(display)}</span>;
// // }

// // /* ------------------------------- document card --------------------------- */
// // function DocCard({ doc, index }) {
// //   const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
// //   return (
// //     <Reveal delay={Math.min(index, 8) * 70} className="h-full">
// //       <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
// //         {/* top accent that draws across on hover */}
// //         <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
// //         {/* corner wash */}
// //         <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

// //         <div className="flex items-start gap-4">
// //           <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
// //             <IconDoc className="w-[22px] h-[22px]" />
// //             <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
// //               PDF
// //             </span>
// //           </div>
// //           <div className="min-w-0 flex-1">
// //             <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
// //               {doc.title}
// //             </h3>
// //             <div className="mt-2 flex items-center gap-2 flex-wrap">
// //               <span
// //                 className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
// //               >
// //                 {doc.type}
// //               </span>
// //               <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
// //                 <IconLayers className="w-3 h-3" /> {doc.pages} pp
// //               </span>
// //               <span className="text-[10px] font-semibold text-gray-400">
// //                 · {formatSize(doc.sizeKB)}
// //               </span>
// //             </div>
// //           </div>
// //         </div>

// //         <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
// //           {doc.abstract}
// //         </p>

// //         <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
// //           <div className="min-w-0">
// //             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
// //               Publication Date
// //             </div>
// //             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
// //               <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
// //               {doc.date}
// //             </div>
// //           </div>
// //           <div className="min-w-0">
// //             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
// //               Author
// //             </div>
// //             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
// //               <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
// //               <span className="truncate">{doc.author}</span>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
// //           <IconDownload className="w-3.5 h-3.5" />
// //           <span className="font-semibold text-gray-500">
// //             {formatDownloads(doc.downloads)}
// //           </span>
// //           <span>downloads</span>
// //           <span className="mx-1 text-gray-300">·</span>
// //           <span>{doc.region}</span>
// //         </div>

// //         <div className="mt-auto pt-5 flex items-stretch gap-2">
// //           <button
// //             onClick={() => openDoc(doc)}
// //             className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
// //           >
// //             <IconDoc className="w-4 h-4" />
// //             View Document
// //           </button>
// //           <button
// //             onClick={() => downloadDoc(doc)}
// //             aria-label={`Download ${doc.title} (PDF)`}
// //             className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
// //           >
// //             <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
// //           </button>
// //         </div>
// //       </article>
// //     </Reveal>
// //   );
// // }

// // /* ------------------------------- stat tile ------------------------------- */
// // function StatTile({ icon: Icon, value, format, label, delay }) {
// //   return (
// //     <Reveal delay={delay} className="h-full">
// //       <div className="group h-full text-center px-3 py-2">
// //         <div className="mx-auto w-11 h-11 rounded-xl bg-[#FAF7F2] flex items-center justify-center text-orange-700 ring-1 ring-orange-200/40 transition-all duration-300 group-hover:bg-orange-600 group-hover:text-white group-hover:scale-110 group-hover:rotate-6">
// //           <Icon className="w-5 h-5" />
// //         </div>
// //         <div className="font-display text-3xl md:text-[34px] font-bold mt-3 bg-gradient-to-r from-red-700 to-orange-600 bg-clip-text text-transparent tabular-nums">
// //           <CountUp value={value} format={format} />
// //         </div>
// //         <div className="text-[12px] font-semibold text-gray-500 mt-1">{label}</div>
// //       </div>
// //     </Reveal>
// //   );
// // }

// // /* ----------------------------- styled select ----------------------------- */
// // function Select({ label, value, onChange, options, allLabel = "All" }) {
// //   return (
// //     <label className="relative block">
// //       <span className="sr-only">{label}</span>
// //       <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
// //         {label}
// //       </span>
// //       <select
// //         value={value}
// //         onChange={(e) => onChange(e.target.value)}
// //         className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
// //       >
// //         <option value="All">{allLabel}</option>
// //         {options.map((o) => (
// //           <option key={o} value={o}>
// //             {o}
// //           </option>
// //         ))}
// //       </select>
// //       <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
// //     </label>
// //   );
// // }

// // /* ----------------------------- breadcrumb ----------------------------- */
// // function Breadcrumb({ label, onHome }) {
// //   return (
// //     <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[12.5px] font-medium mb-5">
// //       <button
// //         onClick={onHome}
// //         className="text-white/60 hover:text-white transition-colors"
// //       >
// //         Global Research
// //       </button>
// //       <span className="text-white/30">/</span>
// //       <span className="text-white/90 font-semibold">{label}</span>
// //     </nav>
// //   );
// // }

// // /* =========================================================================== *
// //  *  REPOSITORY PAGE — shared by the four flagship routes (keyed in App).
// //  * =========================================================================== */
// // export default function ResearchRepository({ categoryKey, navigate, query, setQuery }) {
// //   const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
// //   const CatIcon = meta.icon;

// //   const [activeCat, setActiveCat] = useState(categoryKey);
// //   const [year, setYear] = useState("All");
// //   const [topic, setTopic] = useState("All");
// //   const [region, setRegion] = useState("All");
// //   const [typeF, setTypeF] = useState("All");
// //   const [sort, setSort] = useState("latest");
// //   const [visible, setVisible] = useState(6);
// //   const [filtersOpen, setFiltersOpen] = useState(true);

// //   const opts = useMemo(() => optionsFor(activeCat), [activeCat]);

// //   // Reset filters whenever the active stream changes (via tabs).
// //   useEffect(() => {
// //     setYear("All");
// //     setTopic("All");
// //     setRegion("All");
// //     setTypeF("All");
// //     setVisible(6);
// //   }, [activeCat]);

// //   const activeMeta = CATEGORY_MAP[activeCat];

// //   // Stream-level stats (ignore search + filters so the numbers read as totals).
// //   const pool = useMemo(
// //     () =>
// //       activeCat === "all"
// //         ? DOCUMENTS
// //         : DOCUMENTS.filter((d) => d.category === activeCat),
// //     [activeCat]
// //   );
// //   const maxYear = useMemo(() => Math.max(...pool.map((d) => d.year)), [pool]);
// //   const stats = useMemo(() => {
// //     const totalDownloads = pool.reduce((s, d) => s + d.downloads, 0);
// //     const added = pool.filter((d) => d.year === maxYear).length;
// //     const topics = new Set(pool.map((d) => d.topic)).size;
// //     return [
// //       { icon: IconDoc, value: pool.length, format: (n) => n.toLocaleString(), label: "Research Documents" },
// //       { icon: IconClock, value: added, format: (n) => String(n), label: `Added in ${maxYear}` },
// //       {
// //         icon: IconDownload,
// //         value: totalDownloads,
// //         format: (n) => formatDownloads(n),
// //         label: "Total Downloads",
// //       },
// //       { icon: IconChart, value: topics, format: (n) => String(n), label: activeCat === "all" ? "Topics Covered" : "Topics in Stream" },
// //     ];
// //   }, [pool, maxYear, activeCat]);

// //   // Filtered + sorted result set.
// //   const filtered = useMemo(() => {
// //     const q = query.trim().toLowerCase();
// //     let list = pool.filter((d) => {
// //       if (year !== "All" && String(d.year) !== String(year)) return false;
// //       if (topic !== "All" && d.topic !== topic) return false;
// //       if (region !== "All" && d.region !== region) return false;
// //       if (typeF !== "All" && d.type !== typeF) return false;
// //       if (q) {
// //         const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
// //         if (!hay.includes(q)) return false;
// //       }
// //       return true;
// //     });
// //     list = [...list].sort((a, b) => {
// //       if (sort === "az") return a.title.localeCompare(b.title);
// //       if (sort === "downloads") return b.downloads - a.downloads;
// //       const da = new Date(a.date).getTime();
// //       const db = new Date(b.date).getTime();
// //       return sort === "oldest" ? da - db : db - da;
// //     });
// //     return list;
// //   }, [pool, query, year, topic, region, typeF, sort]);

// //   const shown = filtered.slice(0, visible);
// //   const hasMore = visible < filtered.length;

// //   const activeChips = [];
// //   if (query.trim()) activeChips.push({ k: "q", label: `“${query.trim()}”`, clear: () => setQuery("") });
// //   if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
// //   if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
// //   if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
// //   if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
// //   const clearAll = () => {
// //     setQuery("");
// //     setYear("All");
// //     setTopic("All");
// //     setRegion("All");
// //     setTypeF("All");
// //   };

// //   /* ---- sliding tab indicator ---- */
// //   const trackRef = useRef(null);
// //   const tabRefs = useRef({});
// //   const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
// //   const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
// //   useLayoutEffect(() => {
// //     const measure = () => {
// //       const el = tabRefs.current[activeCat];
// //       if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
// //     };
// //     measure();
// //     const t = setTimeout(measure, 80); // re-measure after webfonts settle
// //     window.addEventListener("resize", measure);
// //     return () => {
// //       clearTimeout(t);
// //       window.removeEventListener("resize", measure);
// //     };
// //   }, [activeCat, activeIndex]);

// //   const scrollToGrid = () => {
// //     document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
// //   };

// //   const selectCls = "flex-1 min-w-[150px]";

// //   return (
// //     <main className="overflow-hidden">
// //       {/* ============================== HERO ============================== */}
// //       <section className="relative overflow-hidden pt-32 md:pt-36 pb-28 md:pb-32">
// //         <div className="absolute inset-0">
// //           <div
// //             className="absolute inset-0"
// //             style={{
// //               background:
// //                 "linear-gradient(150deg, #3a120d 0%, #260907 52%, #140503 100%)",
// //             }}
// //           />
// //           {/* ambient glows */}
// //           <div className="absolute -left-24 top-10 w-[420px] h-[420px] rounded-full bg-orange-500/20 blur-3xl animate-pulse" />
// //           <div className="absolute -right-20 bottom-0 w-[460px] h-[460px] rounded-full bg-red-700/25 blur-3xl animate-pulse delay-1000" />
// //           <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-amber-500/10 blur-3xl" />
// //           {/* animated grid */}
// //           <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
// //             <defs>
// //               <pattern id="rgrid" width="46" height="46" patternUnits="userSpaceOnUse">
// //                 <path d="M 46 0 L 0 0 0 46" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
// //               </pattern>
// //             </defs>
// //             <rect width="100%" height="100%" fill="url(#rgrid)" />
// //           </svg>
// //           {/* floating doc chips (decorative) */}
// //           <div aria-hidden className="hidden lg:block absolute inset-0 pointer-events-none">
// //             <div
// //               className="absolute right-[8%] top-[22%]"
// //               style={{ animation: "floaty 6s ease-in-out infinite", ["--rot"]: "-7deg", animationDelay: "0s" }}
// //             >
// //               <div className="flex items-center gap-2 rounded-xl bg-white/10 backdrop-blur px-3 py-2 ring-1 ring-white/15 text-white/85 text-[12px] font-semibold shadow-xl">
// //                 <span className="w-7 h-7 rounded-lg bg-amber-500/90 text-white grid place-items-center">
// //                   <IconDoc className="w-4 h-4" />
// //                 </span>
// //                 PDF · {formatSize(1820)}
// //               </div>
// //             </div>
// //             <div
// //               className="absolute right-[20%] top-[52%]"
// //               style={{ animation: "floaty 6s ease-in-out infinite", ["--rot"]: "6deg", animationDelay: "1.4s" }}
// //             >
// //               <div className="flex items-center gap-2 rounded-xl bg-white/10 backdrop-blur px-3 py-2 ring-1 ring-white/15 text-white/85 text-[12px] font-semibold shadow-xl">
// //                 <span className="w-7 h-7 rounded-lg bg-red-700/90 text-white grid place-items-center">
// //                   <IconDownload className="w-4 h-4" />
// //                 </span>
// //                 4.2k downloads
// //               </div>
// //             </div>
// //             <div
// //               className="absolute right-[6%] top-[72%]"
// //               style={{ animation: "floaty 6s ease-in-out infinite", ["--rot"]: "-4deg", animationDelay: "2.6s" }}
// //             >
// //               <div className="flex items-center gap-2 rounded-xl bg-white/10 backdrop-blur px-3 py-2 ring-1 ring-white/15 text-white/85 text-[12px] font-semibold shadow-xl">
// //                 <span className="w-7 h-7 rounded-lg bg-orange-500/90 text-white grid place-items-center">
// //                   <IconChart className="w-4 h-4" />
// //                 </span>
// //                 Evidence-based
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
// //           <Reveal>
// //             <div className="max-w-3xl">
// //               <Breadcrumb
// //                 label={activeMeta.label}
// //                 onHome={() => navigate("all")}
// //               />

// //               <div className="inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/5 backdrop-blur px-4 py-1.5">
// //                 <span className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse" />
// //                 <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange-500">
// //                   {meta.eyebrow}
// //                 </span>
// //               </div>

// //               <h1 className="mt-6 font-display text-white text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
// //                 {meta.title.split(" ").slice(0, -2).join(" ")}{" "}
// //                 <span className="relative text-orange-500">
// //                   {meta.title.split(" ").slice(-2).join(" ")}
// //                   <svg className="absolute -bottom-2 left-0 w-full h-1.5" viewBox="0 0 100 4" preserveAspectRatio="none">
// //                     <line x1="0" y1="2" x2="100" y2="2" stroke="currentColor" strokeWidth="2.5" strokeDasharray="7 7" className="text-orange-500/50" />
// //                   </svg>
// //                 </span>
// //               </h1>

// //               <p className="mt-6 text-white/75 max-w-2xl leading-relaxed text-[15px] md:text-[16.5px]">
// //                 {meta.sub}
// //               </p>

// //               {/* integrated search */}
// //               <form
// //                 onSubmit={(e) => {
// //                   e.preventDefault();
// //                   scrollToGrid();
// //                 }}
// //                 className="mt-8 flex items-center gap-2 rounded-2xl bg-white/10 backdrop-blur ring-1 ring-white/20 focus-within:ring-2 focus-within:ring-amber-500/70 focus-within:bg-white/15 transition-all pl-4 pr-2 h-14 max-w-xl shadow-2xl shadow-black/20"
// //               >
// //                 <IconSearch className="w-5 h-5 text-white/70 shrink-0" />
// //                 <input
// //                   value={query}
// //                   onChange={(e) => setQuery(e.target.value)}
// //                   placeholder={`Search ${activeCat === "all" ? "the repository" : "this stream"} by title, topic or author…`}
// //                   className="bg-transparent outline-none text-white placeholder:text-white/55 text-[14px] w-full"
// //                 />
// //                 {query && (
// //                   <button
// //                     type="button"
// //                     onClick={() => setQuery("")}
// //                     aria-label="Clear"
// //                     className="w-7 h-7 rounded-lg grid place-items-center text-white/70 hover:bg-white/15 transition-colors"
// //                   >
// //                     <IconClose className="w-4 h-4" stroke={2.4} />
// //                   </button>
// //                 )}
// //                 <button
// //                   type="submit"
// //                   className="shrink-0 inline-flex items-center gap-1.5 rounded-xl bg-amber-500 hover:bg-orange-600 text-white text-[13px] font-semibold px-4 h-10 transition-colors"
// //                 >
// //                   Search
// //                   <IconArrow className="w-4 h-4" stroke={2.2} />
// //                 </button>
// //               </form>

// //               <div className="mt-6 flex flex-wrap items-center gap-3">
// //                 <button
// //                   onClick={scrollToGrid}
// //                   className="group inline-flex items-center gap-2 rounded-full bg-white text-red-800 text-sm font-semibold px-6 py-3 shadow-lg shadow-black/20 hover:shadow-xl hover:-translate-y-0.5 transition-all"
// //                 >
// //                   Browse Repository
// //                   <IconArrow className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" stroke={2.2} />
// //                 </button>
// //                 <a
// //                   href="mailto:chiefeconomist@assocham.com?subject=Submit%20Research"
// //                   className="inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-white/50 hover:bg-white/5 text-white text-sm font-semibold px-6 py-3 backdrop-blur transition-colors"
// //                 >
// //                   Submit Research
// //                 </a>
// //               </div>
// //             </div>
// //           </Reveal>
// //         </div>

// //         <div className="absolute bottom-0 inset-x-0 h-28 bg-gradient-to-b from-transparent to-[#FAF7F2] pointer-events-none" />
// //       </section>

// //       {/* ====================== FILTER + TABS + GRID ====================== */}
// //       <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
// //         <div className="absolute inset-0 pointer-events-none">
// //           <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
// //           <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
// //         </div>

// //         <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">
// //           {/* ---- category tabs with sliding indicator ----
// //                Centered as a single pill group so tabs read as one aligned
// //                unit at every breakpoint instead of drifting to the left. On
// //                narrow screens the group scrolls horizontally as one block. */}
// //           <Reveal>
// //             <div className="flex justify-center">
// //               <div
// //                 ref={trackRef}
// //                 className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2"
// //               >
// //                 {CATEGORIES.map((c) => {
// //                   const Icon = c.icon;
// //                   const active = c.key === activeCat;
// //                   return (
// //                     <button
// //                       key={c.key}
// //                       ref={(el) => (tabRefs.current[c.key] = el)}
// //                       onClick={() => setActiveCat(c.key)}
// //                       className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
// //                         active ? "text-red-700" : "text-gray-500 hover:text-red-700"
// //                       }`}
// //                     >
// //                       <Icon
// //                         className={`w-4 h-4 shrink-0 transition-colors ${
// //                           active ? "text-orange-600" : "text-gray-400"
// //                         }`}
// //                       />
// //                       <span>{c.label}</span>
// //                     </button>
// //                   );
// //                 })}
// //                 {/* sliding underline */}
// //                 <span
// //                   className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
// //                   style={{
// //                     left: indicator.left,
// //                     width: indicator.width,
// //                     opacity: indicator.ready ? 1 : 0,
// //                   }}
// //                 />
// //                 <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
// //               </div>
// //             </div>
// //           </Reveal>

// //           {/* ---- filter bar ---- */}
// //           <Reveal delay={80}>
// //             <div className="mt-6 bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden">
// //               <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
// //                 <button
// //                   onClick={() => setFiltersOpen((v) => !v)}
// //                   className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
// //                     filtersOpen
// //                       ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
// //                       : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
// //                   }`}
// //                 >
// //                   <IconSliders className="w-4 h-4" />
// //                   Filters
// //                   {activeChips.length > 0 && (
// //                     <span
// //                       className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
// //                         filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
// //                       }`}
// //                     >
// //                       {activeChips.length}
// //                     </span>
// //                   )}
// //                 </button>

// //                 <div className="text-[12.5px] text-gray-500">
// //                   <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
// //                   of {pool.length} documents
// //                 </div>

// //                 <div className="ml-auto flex items-center gap-2">
// //                   <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
// //                   <div className="relative">
// //                     <select
// //                       value={sort}
// //                       onChange={(e) => setSort(e.target.value)}
// //                       className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
// //                     >
// //                       <option value="latest">Latest first</option>
// //                       <option value="oldest">Oldest first</option>
// //                       <option value="downloads">Most downloaded</option>
// //                       <option value="az">Title A–Z</option>
// //                     </select>
// //                     <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* collapsible filters */}
// //               <div
// //                 className={`grid transition-all duration-300 ease-out ${
// //                   filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
// //                 }`}
// //               >
// //                 <div className="overflow-hidden">
// //                   <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
// //                     <div className="flex flex-wrap gap-3">
// //                       <div className={selectCls}>
// //                         <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
// //                       </div>
// //                       <div className={selectCls}>
// //                         <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
// //                       </div>
// //                       <div className={selectCls}>
// //                         <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
// //                       </div>
// //                     </div>

// //                     {/* format chips */}
// //                     <div className="flex items-center gap-2 flex-wrap">
// //                       <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
// //                       {["All", ...opts.types].map((t) => {
// //                         const active = typeF === t;
// //                         return (
// //                           <button
// //                             key={t}
// //                             onClick={() => setTypeF(t)}
// //                             className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
// //                               active
// //                                 ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
// //                                 : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
// //                             }`}
// //                           >
// //                             {t === "All" ? "All formats" : t}
// //                           </button>
// //                         );
// //                       })}
// //                     </div>

// //                     {/* active chips */}
// //                     {activeChips.length > 0 && (
// //                       <div className="flex items-center gap-2 flex-wrap pt-1">
// //                         <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
// //                         {activeChips.map((c) => (
// //                           <button
// //                             key={c.k}
// //                             onClick={c.clear}
// //                             className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
// //                           >
// //                             {c.label}
// //                             <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
// //                               <IconClose className="w-2.5 h-2.5" stroke={3} />
// //                             </span>
// //                           </button>
// //                         ))}
// //                         <button
// //                           onClick={clearAll}
// //                           className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
// //                         >
// //                           Clear all
// //                         </button>
// //                       </div>
// //                     )}
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </Reveal>

// //           {/* ---- results header ---- */}
// //           <div className="mt-8 flex items-center justify-between gap-4">
// //             <div className="flex items-center gap-3">
// //               <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
// //                 <CatIcon className="w-[18px] h-[18px]" />
// //               </span>
// //               <div>
// //                 <div className="font-display text-[15px] font-bold text-gray-900">
// //                   {activeMeta.label}
// //                 </div>
// //                 <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
// //               </div>
// //             </div>
// //           </div>

// //           {/* ---- grid / empty state ---- */}
// //           {filtered.length === 0 ? (
// //             <Reveal>
// //               <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
// //                 <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
// //                   <IconSearch className="w-7 h-7" />
// //                 </div>
// //                 <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
// //                 <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
// //                   Try widening the year or region, clearing the format, or resetting your search.
// //                 </p>
// //                 <button
// //                   onClick={clearAll}
// //                   className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
// //                 >
// //                   <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
// //                 </button>
// //               </div>
// //             </Reveal>
// //           ) : (
// //             <>
// //               <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
// //                 {shown.map((doc, i) => (
// //                   <DocCard key={doc.id} doc={doc} index={i} />
// //                 ))}
// //               </div>

// //               {hasMore && (
// //                 <div className="mt-10 flex justify-center">
// //                   <button
// //                     onClick={() => setVisible((v) => v + 6)}
// //                     className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
// //                   >
// //                     Load More Research Documents
// //                     <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
// //                       <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
// //                     </span>
// //                   </button>
// //                 </div>
// //               )}

// //               {!hasMore && filtered.length > 6 && (
// //                 <div className="mt-10 text-center text-[12.5px] text-gray-400">
// //                   You've reached the end of the {activeMeta.label.toLowerCase()} stream.
// //                 </div>
// //               )}
// //             </>
// //           )}
// //         </div>
// //       </section>
// //     </main>
// //   );
// // }




// // new new code 







// import React, {
//   useEffect,
//   useLayoutEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import {
//   IconArrow,
//   IconDoc,
//   IconSearch,
//   IconDownload,
//   IconChevronDown,
//   IconCalendar,
//   IconUser,
//   IconClose,
//   IconSliders,
//   IconLayers,
//   IconClock,
//   IconChart,
// } from "./icons";
// import {
//   CATEGORIES,
//   CATEGORY_MAP,
//   TYPE_STYLES,
//   DOCUMENTS,
//   optionsFor,
//   formatDownloads,
//   formatSize,
//   openDoc,
//   downloadDoc,
// } from "../data/Research";

// /* ----------------------------- tiny utilities ---------------------------- */
// function useInView(opts = {}) {
//   const ref = useRef(null);
//   const [inView, setInView] = useState(false);
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     const ob = new IntersectionObserver(
//       ([e]) => {
//         if (e.isIntersecting) {
//           setInView(true);
//           ob.disconnect();
//         }
//       },
//       { threshold: 0.12, ...opts }
//     );
//     ob.observe(el);
//     return () => ob.disconnect();
//   }, []);
//   return [ref, inView];
// }

// function Reveal({ children, delay = 0, className = "" }) {
//   const [ref, inView] = useInView();
//   return (
//     <div
//       ref={ref}
//       className={`transition-all duration-700 ease-out ${
//         inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
//       } ${className}`}
//       style={{ transitionDelay: `${delay}ms` }}
//     >
//       {children}
//     </div>
//   );
// }

// function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
//   const [ref, inView] = useInView();
//   const [display, setDisplay] = useState(0);
//   const fromRef = useRef(0);
//   useEffect(() => {
//     if (!inView) return;
//     const from = fromRef.current;
//     const to = value;
//     const start = performance.now();
//     let raf;
//     const tick = (now) => {
//       const t = Math.min(1, (now - start) / duration);
//       const eased = 1 - Math.pow(1 - t, 3);
//       const cur = Math.round(from + (to - from) * eased);
//       setDisplay(cur);
//       if (t < 1) raf = requestAnimationFrame(tick);
//       else fromRef.current = to;
//     };
//     raf = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(raf);
//   }, [inView, value, duration]);
//   return <span ref={ref}>{format(display)}</span>;
// }

// /* ------------------------------- document card --------------------------- */
// function DocCard({ doc, index }) {
//   const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
//   return (
//     <Reveal delay={Math.min(index, 8) * 70} className="h-full">
//       <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
//         <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
//         <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

//         <div className="flex items-start gap-4">
//           <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
//             <IconDoc className="w-[22px] h-[22px]" />
//             <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
//               PDF
//             </span>
//           </div>
//           <div className="min-w-0 flex-1">
//             <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
//               {doc.title}
//             </h3>
//             <div className="mt-2 flex items-center gap-2 flex-wrap">
//               <span
//                 className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
//               >
//                 {doc.type}
//               </span>
//               <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
//                 <IconLayers className="w-3 h-3" /> {doc.pages} pp
//               </span>
//               <span className="text-[10px] font-semibold text-gray-400">
//                 · {formatSize(doc.sizeKB)}
//               </span>
//             </div>
//           </div>
//         </div>

//         <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
//           {doc.abstract}
//         </p>

//         <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
//           <div className="min-w-0">
//             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
//               Publication Date
//             </div>
//             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
//               <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
//               {doc.date}
//             </div>
//           </div>
//           <div className="min-w-0">
//             <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
//               Author
//             </div>
//             <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
//               <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
//               <span className="truncate">{doc.author}</span>
//             </div>
//           </div>
//         </div>

//         <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
//           <IconDownload className="w-3.5 h-3.5" />
//           <span className="font-semibold text-gray-500">
//             {formatDownloads(doc.downloads)}
//           </span>
//           <span>downloads</span>
//           <span className="mx-1 text-gray-300">·</span>
//           <span>{doc.region}</span>
//         </div>

//         <div className="mt-auto pt-5 flex items-stretch gap-2">
//           <button
//             onClick={() => openDoc(doc)}
//             className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
//           >
//             <IconDoc className="w-4 h-4" />
//             View Document
//           </button>
//           <button
//             onClick={() => downloadDoc(doc)}
//             aria-label={`Download ${doc.title} (PDF)`}
//             className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
//           >
//             <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
//           </button>
//         </div>
//       </article>
//     </Reveal>
//   );
// }

// /* ----------------------------- styled select ----------------------------- */
// function Select({ label, value, onChange, options, allLabel = "All" }) {
//   return (
//     <label className="relative block">
//       <span className="sr-only">{label}</span>
//       <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
//         {label}
//       </span>
//       <select
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
//       >
//         <option value="All">{allLabel}</option>
//         {options.map((o) => (
//           <option key={o} value={o}>
//             {o}
//           </option>
//         ))}
//       </select>
//       <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
//     </label>
//   );
// }

// /* ----------------------------- breadcrumb ----------------------------- */
// function Breadcrumb({ label }) {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
//         <li>
//           <a
//             href="/"
//             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li>
//           <span className="transition-colors duration-300 hover:text-[#DA2128]">
//             Global Research
//           </span>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
//           {label}
//         </li>
//       </ol>
//     </nav>
//   );
// }

// /* =========================================================================== *
//  *  REPOSITORY PAGE
//  * =========================================================================== */
// export default function ResearchRepository({ categoryKey, navigate, query, setQuery }) {
//   const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
//   const CatIcon = meta.icon;

//   const [activeCat, setActiveCat] = useState(categoryKey);
//   const [year, setYear] = useState("All");
//   const [topic, setTopic] = useState("All");
//   const [region, setRegion] = useState("All");
//   const [typeF, setTypeF] = useState("All");
//   const [sort, setSort] = useState("latest");
//   const [visible, setVisible] = useState(6);
//   const [filtersOpen, setFiltersOpen] = useState(true);

//   const opts = useMemo(() => optionsFor(activeCat), [activeCat]);

//   // Keep activeCat in sync with the categoryKey prop — this component doesn't
//   // remount on route changes (React Router reuses it), so if the user lands
//   // here via a dropdown/menu link that only changes categoryKey, activeCat
//   // (and therefore the breadcrumb) would otherwise stay stuck on the old value.
//   useEffect(() => {
//     setActiveCat(categoryKey);
//   }, [categoryKey]);

//   useEffect(() => {
//     setYear("All");
//     setTopic("All");
//     setRegion("All");
//     setTypeF("All");
//     setVisible(6);
//   }, [activeCat]);

//   const activeMeta = CATEGORY_MAP[activeCat];

//   const pool = useMemo(
//     () =>
//       activeCat === "all"
//         ? DOCUMENTS
//         : DOCUMENTS.filter((d) => d.category === activeCat),
//     [activeCat]
//   );
//   const maxYear = useMemo(() => Math.max(...pool.map((d) => d.year)), [pool]);

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     let list = pool.filter((d) => {
//       if (year !== "All" && String(d.year) !== String(year)) return false;
//       if (topic !== "All" && d.topic !== topic) return false;
//       if (region !== "All" && d.region !== region) return false;
//       if (typeF !== "All" && d.type !== typeF) return false;
//       if (q) {
//         const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
//         if (!hay.includes(q)) return false;
//       }
//       return true;
//     });
//     list = [...list].sort((a, b) => {
//       if (sort === "az") return a.title.localeCompare(b.title);
//       if (sort === "downloads") return b.downloads - a.downloads;
//       const da = new Date(a.date).getTime();
//       const db = new Date(b.date).getTime();
//       return sort === "oldest" ? da - db : db - da;
//     });
//     return list;
//   }, [pool, query, year, topic, region, typeF, sort]);

//   const shown = filtered.slice(0, visible);
//   const hasMore = visible < filtered.length;

//   const activeChips = [];
//   if (query.trim()) activeChips.push({ k: "q", label: `“${query.trim()}”`, clear: () => setQuery("") });
//   if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
//   if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
//   if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
//   if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
//   const clearAll = () => {
//     setQuery("");
//     setYear("All");
//     setTopic("All");
//     setRegion("All");
//     setTypeF("All");
//   };

//   const trackRef = useRef(null);
//   const tabRefs = useRef({});
//   const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
//   const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
//   useLayoutEffect(() => {
//     const measure = () => {
//       const el = tabRefs.current[activeCat];
//       if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
//     };
//     measure();
//     const t = setTimeout(measure, 80);
//     window.addEventListener("resize", measure);
//     return () => {
//       clearTimeout(t);
//       window.removeEventListener("resize", measure);
//     };
//   }, [activeCat, activeIndex]);

//   const scrollToGrid = () => {
//     document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   const selectCls = "flex-1 min-w-[150px]";

//   return (
//     <main className="overflow-hidden">
//       {/* ============================== HERO ============================== */}
//       <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
//         {/* backdrop decorations, same as AboutSection */}
//         <div className="hero-grid absolute inset-0" />
//         <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
//         <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

//         <Breadcrumb label={activeMeta.label} />

//         <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10  pt-28 sm:pt-32">
//           <Reveal>
//             <div className="max-w-3xl">
//               <div className="inline-flex items-center gap-2.5 rounded-full border border-[#B42318]/15 bg-white/70 backdrop-blur px-4 py-1.5">
//                 <span className="w-1.5 h-1.5 rounded-full bg-[#E8590C] animate-pulse" />
//                 <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#B42318]">
//                   {meta.eyebrow}
//                 </span>
//               </div>

//               <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
//                 {meta.title}
//               </h1>

//               <p className="mt-6 text-gray-600 max-w-2xl leading-relaxed text-[15px] md:text-[16.5px]">
//                 {meta.sub}
//               </p>

              

//               {/* <div className="mt-6 flex flex-wrap items-center gap-3">
//                 <button
//                   onClick={scrollToGrid}
//                   className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#B42318] to-[#E8590C] hover:from-[#94190f] hover:to-[#c94c09] transition-all duration-300 text-white text-sm font-semibold px-6 py-3 shadow-lg shadow-[#E8590C]/25 hover:shadow-xl hover:-translate-y-0.5"
//                 >
//                   Browse Repository
//                   <IconArrow className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" stroke={2.2} />
//                 </button>
//                 <a
//                   href="mailto:chiefeconomist@assocham.com?subject=Submit%20Research"
//                   className="inline-flex items-center gap-2 rounded-full border border-[#B42318]/25 hover:border-[#B42318]/50 hover:bg-white/60 transition-colors duration-300 text-gray-800 text-sm font-semibold px-6 py-3 backdrop-blur"
//                 >
//                   Submit Research
//                 </a>
//               </div> */}
//             </div>
//           </Reveal>
//         </div>

//         {/* bottom shimmer line, same as AboutSection */}
//         <div className="shimmer-line h-px w-full" />
//       </header>

//       {/* ====================== FILTER + TABS + GRID ====================== */}
//       <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
//         <div className="absolute inset-0 pointer-events-none">
//           <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
//           <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
          
//         </div>

        

//         <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">

          
//           {/* ---- category tabs ---- */}
//           <Reveal>
            
//             <div className="flex justify-center">
//               <div
//                 ref={trackRef}
//                 className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2" style={{display: "none"}}
//               >
//                 {CATEGORIES.map((c) => {
//                   const Icon = c.icon;
//                   const active = c.key === activeCat;
//                   return (
//                     <button
//                       key={c.key}
//                       ref={(el) => (tabRefs.current[c.key] = el)}
//                       onClick={() => {
//                         setActiveCat(c.key);
//                         if (c.key !== categoryKey) {
//                           navigate(c.key);
//                         }
//                       }}
//                       className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
//                         active ? "text-red-700" : "text-gray-500 hover:text-red-700"
//                       }`}
//                     >
//                       <Icon
//                         className={`w-4 h-4 shrink-0 transition-colors ${
//                           active ? "text-orange-600" : "text-gray-400"
//                         }`}
//                       />
//                       <span>{c.label}</span>
//                     </button>
//                   );
//                 })}
//                 <span
//                   className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
//                   style={{
//                     left: indicator.left,
//                     width: indicator.width,
//                     opacity: indicator.ready ? 1 : 0,
//                   }}
//                 />
//                 <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
//               </div>
//             </div>
//           </Reveal>

//           {/* ---- filter bar ---- */}
//           <Reveal delay={80}>
//             <div className="mt-6 bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden">
//               <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
//                 <button
//                   onClick={() => setFiltersOpen((v) => !v)}
//                   className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
//                     filtersOpen
//                       ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
//                       : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
//                   }`}
//                 >
//                   <IconSliders className="w-4 h-4" />
//                   Filters
//                   {activeChips.length > 0 && (
//                     <span
//                       className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
//                         filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
//                       }`}
//                     >
//                       {activeChips.length}
//                     </span>
//                   )}
//                 </button>

//                 <div className="text-[12.5px] text-gray-500">
//                   <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
//                   of {pool.length} documents
//                 </div>

//                 <div className="ml-auto flex items-center gap-2">
//                   <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
//                   <div className="relative">
//                     <select
//                       value={sort}
//                       onChange={(e) => setSort(e.target.value)}
//                       className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
//                     >
//                       <option value="latest">Latest first</option>
//                       <option value="oldest">Oldest first</option>
//                       <option value="downloads">Most downloaded</option>
//                       <option value="az">Title A–Z</option>
//                     </select>
//                     <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
//                   </div>
//                 </div>
//               </div>

//               {/* collapsible filters */}
//               <div
//                 className={`grid transition-all duration-300 ease-out ${
//                   filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
//                 }`}
//               >
//                 <div className="overflow-hidden">
//                   <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
//                     <div className="flex flex-wrap gap-3">
//                       <div className={selectCls}>
//                         <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
//                       </div>
//                       <div className={selectCls}>
//                         <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
//                       </div>
//                       <div className={selectCls}>
//                         <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
//                       </div>
//                     </div>

//                     <div className="flex items-center gap-2 flex-wrap">
//                       <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
//                       {["All", ...opts.types].map((t) => {
//                         const active = typeF === t;
//                         return (
//                           <button
//                             key={t}
//                             onClick={() => setTypeF(t)}
//                             className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
//                               active
//                                 ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
//                                 : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
//                             }`}
//                           >
//                             {t === "All" ? "All formats" : t}
//                           </button>
//                         );
//                       })}
//                     </div>

//                     {activeChips.length > 0 && (
//                       <div className="flex items-center gap-2 flex-wrap pt-1">
//                         <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
//                         {activeChips.map((c) => (
//                           <button
//                             key={c.k}
//                             onClick={c.clear}
//                             className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
//                           >
//                             {c.label}
//                             <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
//                               <IconClose className="w-2.5 h-2.5" stroke={3} />
//                             </span>
//                           </button>
//                         ))}
//                         <button
//                           onClick={clearAll}
//                           className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
//                         >
//                           Clear all
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Reveal>

//           {/* ---- results header ---- */}
//           <div className="mt-8 flex items-center justify-between gap-4">
//             <div className="flex items-center gap-3">
//               <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
//                 <CatIcon className="w-[18px] h-[18px]" />
//               </span>
//               <div>
//                 <div className="font-display text-[15px] font-bold text-gray-900">
//                   {activeMeta.label}
//                 </div>
//                 <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
//               </div>
//             </div>
//           </div>

//           {/* ---- grid ---- */}
//           {filtered.length === 0 ? (
//             <Reveal>
//               <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
//                 <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
//                   <IconSearch className="w-7 h-7" />
//                 </div>
//                 <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
//                 <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
//                   Try widening the year or region, clearing the format, or resetting your search.
//                 </p>
//                 <button
//                   onClick={clearAll}
//                   className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
//                 >
//                   <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
//                 </button>
//               </div>
//             </Reveal>
//           ) : (
//             <>
//               <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
//                 {shown.map((doc, i) => (
//                   <DocCard key={doc.id} doc={doc} index={i} />
//                 ))}
//               </div>

//               {hasMore && (
//                 <div className="mt-10 flex justify-center">
//                   <button
//                     onClick={() => setVisible((v) => v + 6)}
//                     className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
//                   >
//                     Load More Research Documents
//                     <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
//                       <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
//                     </span>
//                   </button>
//                 </div>
//               )}

//               {!hasMore && filtered.length > 6 && (
//                 <div className="mt-10 text-center text-[12.5px] text-gray-400">
//                   You've reached the end of the {activeMeta.label.toLowerCase()} stream.
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </section>
//     </main>
//   );
// }





// new new code 






import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  IconArrow,
  IconDoc,
  IconSearch,
  IconDownload,
  IconChevronDown,
  IconCalendar,
  IconUser,
  IconClose,
  IconSliders,
  IconLayers,
  IconClock,
  IconChart,
} from "./icons";
import {
  CATEGORIES,
  CATEGORY_MAP,
  TYPE_STYLES,
  DOCUMENTS,
  optionsFor,
  formatDownloads,
  formatSize,
  openDoc,
  downloadDoc,
} from "../data/Research";

/* ----------------------------- tiny utilities ---------------------------- */
function useInView(opts = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ob = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          ob.disconnect();
        }
      },
      { threshold: 0.12, ...opts }
    );
    ob.observe(el);
    return () => ob.disconnect();
  }, []);
  return [ref, inView];
}

function Reveal({ children, delay = 0, className = "" }) {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

function CountUp({ value, format = (n) => String(n), duration = 1100 }) {
  const [ref, inView] = useInView();
  const [display, setDisplay] = useState(0);
  const fromRef = useRef(0);
  useEffect(() => {
    if (!inView) return;
    const from = fromRef.current;
    const to = value;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const cur = Math.round(from + (to - from) * eased);
      setDisplay(cur);
      if (t < 1) raf = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);
  return <span ref={ref}>{format(display)}</span>;
}

/* ------------------------------- document card --------------------------- */
function DocCard({ doc, index }) {
  const typeCls = TYPE_STYLES[doc.type] || TYPE_STYLES.REPORT;
  return (
    <Reveal delay={Math.min(index, 8) * 70} className="h-full">
      <article className="group relative flex flex-col h-full bg-white rounded-2xl p-6 ring-1 ring-orange-200/50 shadow-sm hover:shadow-2xl hover:shadow-red-900/10 transition-all duration-300 hover:-translate-y-1.5 overflow-hidden">
        <span className="absolute top-0 left-0 h-[3px] w-10 rounded-r-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-500 group-hover:w-full" />
        <span className="pointer-events-none absolute -top-12 -right-12 w-28 h-28 rounded-full bg-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="flex items-start gap-4">
          <div className="relative w-12 h-12 shrink-0 rounded-xl bg-gradient-to-br from-[#FAF7F2] to-white ring-1 ring-orange-200/30 grid place-items-center text-red-700 transition-all duration-300 group-hover:from-red-700 group-hover:to-orange-600 group-hover:text-white group-hover:scale-105 group-hover:-rotate-3">
            <IconDoc className="w-[22px] h-[22px]" />
            <span className="absolute -bottom-1.5 -right-1.5 text-[8px] font-extrabold tracking-wider bg-red-700 text-white rounded px-1 py-px ring-2 ring-white group-hover:bg-white group-hover:text-red-700 transition-colors">
              PDF
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="font-display text-[15.5px] leading-snug text-gray-900 line-clamp-2 group-hover:text-red-700 transition-colors duration-200">
              {doc.title}
            </h3>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <span
                className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ring-1 ${typeCls}`}
              >
                {doc.type}
              </span>
              <span className="text-[10px] font-semibold text-gray-400 inline-flex items-center gap-1">
                <IconLayers className="w-3 h-3" /> {doc.pages} pp
              </span>
              <span className="text-[10px] font-semibold text-gray-400">
                · {formatSize(doc.sizeKB)}
              </span>
            </div>
          </div>
        </div>

        <p className="mt-4 text-[13px] leading-relaxed text-gray-600 line-clamp-3">
          {doc.abstract}
        </p>

        <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-orange-200/30 pt-4">
          <div className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
              Publication Date
            </div>
            <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5">
              <IconCalendar className="w-3.5 h-3.5 text-orange-700" />
              {doc.date}
            </div>
          </div>
          <div className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
              Author
            </div>
            <div className="mt-1 text-[12.5px] font-semibold text-gray-800 inline-flex items-center gap-1.5 min-w-0">
              <IconUser className="w-3.5 h-3.5 text-orange-700 shrink-0" />
              <span className="truncate">{doc.author}</span>
            </div>
          </div>
        </div>

        <div className="mt-3 flex items-center gap-1.5 text-[11px] text-gray-400">
          <IconDownload className="w-3.5 h-3.5" />
          <span className="font-semibold text-gray-500">
            {formatDownloads(doc.downloads)}
          </span>
          <span>downloads</span>
          <span className="mx-1 text-gray-300">·</span>
          <span>{doc.region}</span>
        </div>

        <div className="mt-auto pt-5 flex items-stretch gap-2">
          <button
            onClick={() => openDoc(doc)}
            className="group/btn flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-red-700 to-red-800 text-white text-[13px] font-semibold py-2.5 shadow-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300 hover:shadow-lg hover:shadow-red-700/30"
          >
            <IconDoc className="w-4 h-4" />
            View Document
          </button>
          <button
            onClick={() => downloadDoc(doc)}
            aria-label={`Download ${doc.title} (PDF)`}
            className="w-11 shrink-0 grid place-items-center rounded-lg bg-[#FAF7F2] text-red-700 ring-1 ring-orange-200/30 hover:bg-amber-500 hover:text-white hover:ring-amber-500 transition-all duration-300"
          >
            <IconDownload className="w-[18px] h-[18px] transition-transform duration-300 group-hover:translate-y-0.5" />
          </button>
        </div>
      </article>
    </Reveal>
  );
}

/* ----------------------------- styled select ----------------------------- */
function Select({ label, value, onChange, options, allLabel = "All" }) {
  return (
    <label className="relative block">
      <span className="sr-only">{label}</span>
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold uppercase tracking-wider text-gray-400 pointer-events-none">
        {label}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 focus:bg-white outline-none text-[13px] font-semibold text-gray-700 pl-[68px] pr-9 py-2.5 cursor-pointer transition"
      >
        <option value="All">{allLabel}</option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
      <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
    </label>
  );
}

/* ------------------------- hover-expanding search ------------------------- */
function HoverSearch({ query, setQuery, activeCat, onSubmit }) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
      className="group/search relative flex items-center gap-2 rounded-full bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus-within:ring-2 focus-within:ring-orange-500/70 hover:bg-white focus-within:bg-white transition-all duration-300 ease-out h-10 w-10 hover:w-64 focus-within:w-64 pl-2.5 pr-1 overflow-hidden shrink-0"
    >
      <IconSearch className="w-4 h-4 text-orange-700 shrink-0" />
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={`Search ${activeCat === "all" ? "repository" : "stream"}…`}
        className="bg-transparent outline-none text-gray-900 placeholder:text-gray-400 text-[13px] w-full min-w-0 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200 delay-100"
      />
      {query && (
        <button
          type="button"
          onClick={() => setQuery("")}
          aria-label="Clear search"
          className="w-6 h-6 shrink-0 rounded-full grid place-items-center text-gray-400 hover:bg-gray-100 hover:text-red-700 opacity-0 group-hover/search:opacity-100 group-focus-within/search:opacity-100 transition-opacity duration-200"
        >
          <IconClose className="w-3.5 h-3.5" stroke={2.4} />
        </button>
      )}
    </form>
  );
}

/* ----------------------------- breadcrumb ----------------------------- */
function Breadcrumb({ label }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="/"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li>
          <span className="transition-colors duration-300 hover:text-[#DA2128]">
            Global Research
          </span>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">
          {label}
        </li>
      </ol>
    </nav>
  );
}

/* =========================================================================== *
 *  REPOSITORY PAGE
 * =========================================================================== */
export default function ResearchRepository({ categoryKey, navigate, query, setQuery }) {
  const meta = CATEGORY_MAP[categoryKey] || CATEGORY_MAP.all;
  const CatIcon = meta.icon;

  const [activeCat, setActiveCat] = useState(categoryKey);
  const [year, setYear] = useState("All");
  const [topic, setTopic] = useState("All");
  const [region, setRegion] = useState("All");
  const [typeF, setTypeF] = useState("All");
  const [sort, setSort] = useState("latest");
  const [visible, setVisible] = useState(6);
  const [filtersOpen, setFiltersOpen] = useState(true);

  const opts = useMemo(() => optionsFor(activeCat), [activeCat]);

  // Keep activeCat in sync with the categoryKey prop — this component doesn't
  // remount on route changes (React Router reuses it), so if the user lands
  // here via a dropdown/menu link that only changes categoryKey, activeCat
  // (and therefore the breadcrumb) would otherwise stay stuck on the old value.
  useEffect(() => {
    setActiveCat(categoryKey);
  }, [categoryKey]);

  useEffect(() => {
    setYear("All");
    setTopic("All");
    setRegion("All");
    setTypeF("All");
    setVisible(6);
  }, [activeCat]);

  const activeMeta = CATEGORY_MAP[activeCat];

  const pool = useMemo(
    () =>
      activeCat === "all"
        ? DOCUMENTS
        : DOCUMENTS.filter((d) => d.category === activeCat),
    [activeCat]
  );
  const maxYear = useMemo(() => Math.max(...pool.map((d) => d.year)), [pool]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    let list = pool.filter((d) => {
      if (year !== "All" && String(d.year) !== String(year)) return false;
      if (topic !== "All" && d.topic !== topic) return false;
      if (region !== "All" && d.region !== region) return false;
      if (typeF !== "All" && d.type !== typeF) return false;
      if (q) {
        const hay = `${d.title} ${d.abstract} ${d.author} ${d.topic} ${d.type}`.toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });
    list = [...list].sort((a, b) => {
      if (sort === "az") return a.title.localeCompare(b.title);
      if (sort === "downloads") return b.downloads - a.downloads;
      const da = new Date(a.date).getTime();
      const db = new Date(b.date).getTime();
      return sort === "oldest" ? da - db : db - da;
    });
    return list;
  }, [pool, query, year, topic, region, typeF, sort]);

  const shown = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  const activeChips = [];
  if (query.trim()) activeChips.push({ k: "q", label: `“${query.trim()}”`, clear: () => setQuery("") });
  if (year !== "All") activeChips.push({ k: "y", label: `Year: ${year}`, clear: () => setYear("All") });
  if (topic !== "All") activeChips.push({ k: "t", label: topic, clear: () => setTopic("All") });
  if (region !== "All") activeChips.push({ k: "r", label: region, clear: () => setRegion("All") });
  if (typeF !== "All") activeChips.push({ k: "f", label: typeF, clear: () => setTypeF("All") });
  const clearAll = () => {
    setQuery("");
    setYear("All");
    setTopic("All");
    setRegion("All");
    setTypeF("All");
  };

  const trackRef = useRef(null);
  const tabRefs = useRef({});
  const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });
  const activeIndex = CATEGORIES.findIndex((c) => c.key === activeCat);
  useLayoutEffect(() => {
    const measure = () => {
      const el = tabRefs.current[activeCat];
      if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
    };
    measure();
    const t = setTimeout(measure, 80);
    window.addEventListener("resize", measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, [activeCat, activeIndex]);

  const scrollToGrid = () => {
    document.getElementById("repo-grid")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const selectCls = "flex-1 min-w-[150px]";

  return (
    <main className="overflow-hidden">
      {/* ============================== HERO ============================== */}
      <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
        {/* backdrop decorations, same as AboutSection */}
        <div className="hero-grid absolute inset-0" />
        <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
        <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

        <Breadcrumb label={activeMeta.label} />

        <div className="relative w-full max-w-[1280px] mx-auto px-6 lg:px-10  pt-28 sm:pt-32">
          <Reveal>
            <div className="max-w-3xl m-auto text-center">
              <div className="inline-flex items-center gap-2.5 rounded-full border border-[#B42318]/15 bg-white/70 backdrop-blur px-4 py-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E8590C] animate-pulse" />
                <span className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#B42318]">
                  {meta.eyebrow}
                </span>
              </div>

              <h1 className="mt-6 font-display text-gray-900 text-4xl sm:text-5xl md:text-[56px] leading-[1.05] tracking-tight [text-wrap:balance]">
                {meta.title}
              </h1>

              <p className="mt-6 text-gray-600 max-w-2xl leading-relaxed text-[15px] md:text-[16.5px]">
                {meta.sub}
              </p>
            </div>
          </Reveal>
        </div>

        {/* bottom shimmer line, same as AboutSection */}
        <div className="shimmer-line h-px w-full" />
      </header>

      {/* ====================== FILTER + TABS + GRID ====================== */}
      <section id="repo-grid" className="scroll-mt-24 py-16 md:py-20 bg-[#FAF7F2] relative">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-20 right-0 w-80 h-80 rounded-full bg-orange-500/5 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-red-700/5 blur-3xl" />
        </div>

        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 relative">

          {/* ---- category tabs ---- */}
          <Reveal>
            <div className="flex justify-center">
              <div
                ref={trackRef}
                className="relative inline-flex items-stretch gap-1 max-w-full overflow-x-auto no-scrollbar rounded-t-2xl bg-white/50 ring-1 ring-orange-200/30 px-2" style={{display: "none"}}
              >
                {CATEGORIES.map((c) => {
                  const Icon = c.icon;
                  const active = c.key === activeCat;
                  return (
                    <button
                      key={c.key}
                      ref={(el) => (tabRefs.current[c.key] = el)}
                      onClick={() => {
                        setActiveCat(c.key);
                        if (c.key !== categoryKey) {
                          navigate(c.key);
                        }
                      }}
                      className={`relative shrink-0 inline-flex items-center justify-center gap-2 rounded-t-lg px-4 md:px-5 py-3 text-[13.5px] font-semibold whitespace-nowrap leading-none transition-colors duration-200 ${
                        active ? "text-red-700" : "text-gray-500 hover:text-red-700"
                      }`}
                    >
                      <Icon
                        className={`w-4 h-4 shrink-0 transition-colors ${
                          active ? "text-orange-600" : "text-gray-400"
                        }`}
                      />
                      <span>{c.label}</span>
                    </button>
                  );
                })}
                <span
                  className="absolute bottom-0 h-[2.5px] rounded-full bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 transition-all duration-300 ease-out"
                  style={{
                    left: indicator.left,
                    width: indicator.width,
                    opacity: indicator.ready ? 1 : 0,
                  }}
                />
                <span className="absolute bottom-0 inset-x-2 h-px bg-orange-200/30" />
              </div>
            </div>
          </Reveal>

          {/* ---- filter bar ---- */}
          <Reveal delay={80}>
            <div className="mt-6 bg-white rounded-2xl ring-1 ring-orange-200/30 shadow-sm overflow-hidden">
              <div className="flex items-center gap-3 flex-wrap p-4 md:p-5">
                <button
                  onClick={() => setFiltersOpen((v) => !v)}
                  className={`inline-flex items-center gap-2 rounded-xl px-3.5 h-10 text-[13px] font-semibold transition-colors ${
                    filtersOpen
                      ? "bg-red-700 text-white shadow-sm shadow-red-700/30"
                      : "bg-[#FAF7F2] text-gray-700 ring-1 ring-orange-200/30 hover:ring-orange-400/60"
                  }`}
                >
                  <IconSliders className="w-4 h-4" />
                  Filters
                  {activeChips.length > 0 && (
                    <span
                      className={`min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold ${
                        filtersOpen ? "bg-white/25 text-white" : "bg-red-700 text-white"
                      }`}
                    >
                      {activeChips.length}
                    </span>
                  )}
                </button>

                <div className="text-[12.5px] text-gray-500">
                  <span className="font-bold text-gray-800">{filtered.length}</span>{" "}
                  of {pool.length} documents
                </div>

                {/* ---- right side: hover-expanding search + sort ---- */}
                <div className="ml-auto flex items-center gap-2">
                  <HoverSearch
                    query={query}
                    setQuery={setQuery}
                    activeCat={activeCat}
                    onSubmit={scrollToGrid}
                  />

                  <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hidden sm:inline">Sort</span>
                  <div className="relative">
                    <select
                      value={sort}
                      onChange={(e) => setSort(e.target.value)}
                      className="appearance-none rounded-xl bg-[#FAF7F2] ring-1 ring-orange-200/30 hover:ring-orange-400/60 focus:ring-2 focus:ring-orange-500/70 outline-none text-[13px] font-semibold text-gray-700 pl-3 pr-9 py-2.5 cursor-pointer transition"
                    >
                      <option value="latest">Latest first</option>
                      <option value="oldest">Oldest first</option>
                      <option value="downloads">Most downloaded</option>
                      <option value="az">Title A–Z</option>
                    </select>
                    <IconChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-700 pointer-events-none" stroke={2.2} />
                  </div>
                </div>
              </div>

              {/* collapsible filters */}
              <div
                className={`grid transition-all duration-300 ease-out ${
                  filtersOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-4 md:px-5 pb-4 md:pb-5 border-t border-orange-200/30 pt-4 space-y-4">
                    <div className="flex flex-wrap gap-3">
                      <div className={selectCls}>
                        <Select label="Year" value={year} onChange={setYear} options={opts.years.map(String)} allLabel="All years" />
                      </div>
                      <div className={selectCls}>
                        <Select label="Topic" value={topic} onChange={setTopic} options={opts.topics} />
                      </div>
                      <div className={selectCls}>
                        <Select label="Region" value={region} onChange={setRegion} options={opts.regions} />
                      </div>
                    </div>

                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Format</span>
                      {["All", ...opts.types].map((t) => {
                        const active = typeF === t;
                        return (
                          <button
                            key={t}
                            onClick={() => setTypeF(t)}
                            className={`rounded-full px-3 py-1 text-[12px] font-semibold ring-1 transition-all duration-200 ${
                              active
                                ? "bg-red-700 text-white ring-red-700 shadow-sm shadow-red-700/30 scale-[1.03]"
                                : "bg-white text-gray-600 ring-orange-200/30 hover:ring-orange-400/60 hover:text-red-700"
                            }`}
                          >
                            {t === "All" ? "All formats" : t}
                          </button>
                        );
                      })}
                    </div>

                    {activeChips.length > 0 && (
                      <div className="flex items-center gap-2 flex-wrap pt-1">
                        <span className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mr-1">Active</span>
                        {activeChips.map((c) => (
                          <button
                            key={c.k}
                            onClick={c.clear}
                            className="inline-flex items-center gap-1.5 rounded-full bg-orange-100 text-orange-800 ring-1 ring-orange-200/50 pl-3 pr-2 py-1 text-[12px] font-semibold hover:bg-orange-200/50 transition-colors"
                          >
                            {c.label}
                            <span className="w-4 h-4 rounded-full grid place-items-center bg-orange-200/50 hover:bg-orange-600 hover:text-white transition-colors">
                              <IconClose className="w-2.5 h-2.5" stroke={3} />
                            </span>
                          </button>
                        ))}
                        <button
                          onClick={clearAll}
                          className="text-[12px] font-semibold text-red-700 hover:underline underline-offset-2 ml-1"
                        >
                          Clear all
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* ---- results header ---- */}
          <div className="mt-8 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-700 to-orange-600 text-white grid place-items-center ring-1 ring-white/20">
                <CatIcon className="w-[18px] h-[18px]" />
              </span>
              <div>
                <div className="font-display text-[15px] font-bold text-gray-900">
                  {activeMeta.label}
                </div>
                <div className="text-[12px] text-gray-500">{activeMeta.short}</div>
              </div>
            </div>
          </div>

          {/* ---- grid ---- */}
          {filtered.length === 0 ? (
            <Reveal>
              <div className="mt-6 rounded-2xl bg-white ring-1 ring-orange-200/30 p-12 text-center">
                <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FAF7F2] ring-1 ring-orange-200/30 grid place-items-center text-orange-700">
                  <IconSearch className="w-7 h-7" />
                </div>
                <h3 className="mt-5 font-display text-xl text-gray-900">No documents match your filters</h3>
                <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
                  Try widening the year or region, clearing the format, or resetting your search.
                </p>
                <button
                  onClick={clearAll}
                  className="mt-6 inline-flex items-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
                >
                  <IconClose className="w-4 h-4" stroke={2.4} /> Clear all filters
                </button>
              </div>
            </Reveal>
          ) : (
            <>
              <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {shown.map((doc, i) => (
                  <DocCard key={doc.id} doc={doc} index={i} />
                ))}
              </div>

              {hasMore && (
                <div className="mt-10 flex justify-center">
                  <button
                    onClick={() => setVisible((v) => v + 6)}
                    className="group inline-flex items-center gap-2.5 rounded-full bg-white ring-1 ring-orange-200/40 hover:ring-orange-500/70 text-gray-800 text-sm font-semibold px-7 py-3.5 shadow-sm hover:shadow-lg hover:shadow-orange-500/10 transition-all"
                  >
                    Load More Research Documents
                    <span className="w-6 h-6 rounded-full grid place-items-center bg-red-700/10 text-red-700 transition-all duration-300 group-hover:bg-red-700 group-hover:text-white group-hover:rotate-180">
                      <IconChevronDown className="w-3.5 h-3.5" stroke={2.6} />
                    </span>
                  </button>
                </div>
              )}

              {!hasMore && filtered.length > 6 && (
                <div className="mt-10 text-center text-[12.5px] text-gray-400">
                  You've reached the end of the {activeMeta.label.toLowerCase()} stream.
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </main>
  );
}